module.exports = __webpack_public_path__ + "static/media/buck3.6ed7caee.png";